<template>
  <v-app>
    <v-tabs
      v-model="currentTab"
      centered
      color="transparent"   
      light
      fixed-tabs
    >
      <v-tabs-slider color="0099E1"></v-tabs-slider>
      <v-tab 
        v-for="tab in tabs"
        :href="'#tab-' + tab.name"
        :key="tab.name"
        :id="tab.name"
      >
        {{tab.name}}
      </v-tab>

      <v-tabs-items touchless v-model="currentTab">
        <v-tab-item
          v-for="tab in tabs"
          :value="'tab-' + tab.name"
          :key="tab.name"
        >
          <v-card color="transparent" flat>
              <component :is="tab.component" ref="childComponent" :firstEntry="firstEntry" :deviceCreated="deviceCreated"></component>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-app>
</template>

<script>

import PProfile from '@/components/User/Profile';
import POrganization from '@/components/User/Organization';

export default {
  name: 'userInfo',
  components: {
    PProfile,
    POrganization
  },
  data () {
    return {
      currentTab: 'tab-Organización',
      tabs: [
        {
          name: 'Perfil',
          component: 'PProfile'
        },
        {
          name: 'Organización',
          component: 'POrganization'
        }
      ],
      firstEntry: this.$route.params.firstEntry,
      deviceCreated: this.$route.params.deviceCreated
    };
  },
  watch: {
    currentTab (value) {
      if (value === 'tab-Organización') {
        mixpanel.track('Click user info tab-organizacion');
        gtag('event', 'tab_organizacion', {event_category: 'click', event_label: 'Click user info tab-organizacion'});
      } else {
        mixpanel.track('Click user info tab-perfil');
        gtag('event', 'tab_perfil', {event_category: 'click', event_label: 'Click user info tab-perfil'});
      }
    }
  },
  methods: {
    goBack () {
      // TODO
    }
  }
};
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// UserInfo.vue?b5ab4ec2